export const entityFormStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2
	}
};
